import { queryString } from '@shared/hooks/recoil-query';
import { api_ } from '@shared/plugIn/axios';
import { AlertMethod, LowerRole } from '@shared/types';
import qs from 'qs';

import { Bugo, BugoCreate, BugoUpdate } from './bugo.interface';

const createBugo = async (bugoCreate: BugoCreate, bugoRole: LowerRole) => {
  const { data: bugo } = await api_.post<Bugo>(`/${bugoRole}/bugo`, bugoCreate);
  return bugo;
};

const updateBugo = async (bugoUpdate: BugoUpdate, bugoRole: LowerRole) => {
  const { data: bugo } = await api_.patch<Bugo>(
    `/${bugoRole}/bugo/${bugoUpdate._id}`,
    bugoUpdate,
  );
  return bugo;
};

const sendBugo = async (
  bugoIdList: string[],
  bugoRole: LowerRole,
  alertMethod?: AlertMethod,
) => {
  const { data: result } = await api_.get(
    `/${bugoRole}/alert/bugo?${qs.stringify(
      {
        bugos: JSON.stringify(bugoIdList),
        method: alertMethod,
      },
      {
        encode: false,
      },
    )}`,
  );
  return result;
};

const sendCourtesy = async (
  bugoIdList: string[],
  bugoRole: LowerRole,
  alertMethod?: AlertMethod,
) => {
  const { data: result } = await api_.get(
    `/${bugoRole}/alert/courtesy?${qs.stringify(
      {
        bugos: JSON.stringify(bugoIdList),
        method: alertMethod,
      },
      {
        encode: false,
      },
    )}`,
  );
  return result;
};

/**
 * 해당 상조(bugoBrand)의 가장 최근 부고 id. (관리자 전용 — admin 제네릭 조회)
 * 답례품 스토어 미리보기처럼 "그 상조의 아무 부고나 하나" 필요할 때 쓴다.
 * 부고가 하나도 없는 상조면 null.
 */
const findLatestBugoIdByBugoBrand = async (bugoBrandId: string): Promise<string | null> => {
  const { data } = await api_.get<Pick<Bugo, '_id'>[]>(
    `/admin/bugo?${queryString({
      filter: { bugoBrand: bugoBrandId },
      options: { sort: { _id: -1 }, limit: 1 },
      select: '_id',
    })}`,
  );
  return data?.[0]?._id ?? null;
};

export { createBugo, updateBugo, sendBugo, sendCourtesy, findLatestBugoIdByBugoBrand };
